<template>
    <mdb-list-group class="group-fly-ticket">
        <div>
            <h5>{{title}}</h5>
        </div>
        <mdb-list-group-item v-for="(flight, index) in flights" :key="index" :action="true" :href="flight.url"
                             :class="{'grey lighten-2': index % 2 === 0, 'white': index % 2 !== 0 }"
                             tag="a" class="row ml-0">
                <div class="col-12 col-md-3 p-0 ">{{flight.from_city_name}} ({{flight.from_code}})</div>
                <div class="col-12 col-md-3 p-0 ">
                    <img v-if="index % 2 === 0" src="../assets/images/Ucak_Gri.gif" width="90" />
                    <img v-else src="../assets/images/Ucak_beyaz.gif" width="90" />
                </div>
                <div class="col-12 col-md-3 p-0 ">{{flight.to_city_name}} ({{flight.to_code}})</div>
                <div class="col-12 col-md-2 p-0 text-right price"> {{flight.price.slice(0,-3)}}{{currency[flight.currency_id-1]}} </div>
            </mdb-list-group-item>
        <mdb-list-group-item
                :action="true" href="#" tag="a"
                :active="true">
            <span>En Uygun Yurt İçi Uçak Biletini Bul! </span> <img src="../assets/images/Search.png" width="25">
        </mdb-list-group-item>
    </mdb-list-group>
</template>

<script>
    import { mdbListGroup, mdbListGroupItem,mdbIcon } from 'mdbvue';
    import axios from "axios";
    export default {
        name: "firstLeftSide.vue",
        components: {
            mdbListGroup,
            mdbListGroupItem,
            mdbIcon
        },
        data: () => ({
        title:'Yurt İçi En Uygun Uçak Biletleri',
        plane:'plane-departure',
        icon:'chevron-right',
        currency : ['₺','$','€'],
        flights: [
            /*{
                name:'Antalya (AYT) - İstanbul (IST)',
                date:'30 Ağustos 2019',
                plane:'plane-departure',
                icon:'chevron-right',
                price:'3.285₺',
                link:'#'
            }, {
                name:'Antalya (AYT) - İstanbul (IST)',
                date:'30 Ağustos 2019',
                plane:'plane-departure',
                icon:'chevron-right',
                price:'3.285₺',
                link:'#'
            }, {
                name:'Antalya (AYT) - İstanbul (IST)',
                date:'30 Ağustos 2019',
                plane:'plane-departure',
                icon:'chevron-right',
                price:'3.285₺',
                link:'#'
            }, {
                name:'Antalya (AYT) - İstanbul (IST)',
                date:'30 Ağustos 2019',
                plane:'plane-departure',
                icon:'chevron-right',
                price:'3.285₺',
                link:'#'
            },*/
        ],

    }),
    mounted() {

        axios.get("https://www.biletbul.com/backend/public/api/v1/destination/category/1",{
            headers: {

            }
        })
            .then(response => this.flights=[...response.data.data])
    }
    }
</script>

<style scoped>

</style>
